import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';

const styles = theme => ({
    pickerTextFieldInput: {
        padding: '8px',
        fontSize: '14px',
        textAlign: 'center',
    },
    pickerTextFieldRoot: {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
});

const getPickerTextField = (classes, props) => {
    const { pickerTextFieldInput: pickerTextFieldInputCls, pickerTextFieldRoot: pickerTextFieldRootCls } = classes;
    return <TextField {...props} size="small" InputProps={{ disableUnderline: true, classes: { root: pickerTextFieldRootCls, input: pickerTextFieldInputCls, inputMarginDense: pickerTextFieldInputCls } }} />;
};

const AfitdTimePicker = props => {
    const { isHidden, children, classes, ...otherProps } = props;
    // const classes = useStyles();

    const defaultTimePickerProps = {
        format: 'h:mm a',
        autoOk: false,
        variant: 'dialog',
        inputVariant: 'filled',
        TextFieldComponent: getPickerTextField.bind(null, classes),
    };

    if (isHidden) {
        return null;
    } else {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                    inputProps={{
                        step: 600, // 5 min
                    }}
                    {...defaultTimePickerProps}
                    {...otherProps}
                />
            </MuiPickersUtilsProvider>
        );
    }
};

export default withStyles(styles)(AfitdTimePicker);
